import { render } from "./9.GetInTouch.vue?vue&type=template&id=5146b088&scoped=true"
import script from "./9.GetInTouch.vue?vue&type=script&lang=js"
export * from "./9.GetInTouch.vue?vue&type=script&lang=js"

import "./9.GetInTouch.vue?vue&type=style&index=0&id=5146b088&lang=css"
import "./9.GetInTouch.vue?vue&type=style&index=1&id=5146b088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5146b088"]])

export default __exports__